<template>
    <div class="submit-spc-order">
        <el-form ref="form" label-width="100px" label-position="left">
            <div class="form-title mt10">
                <svg-icon icon-class="lm" class-name="lm-icon" />
                客户信息
            </div>
            <div class="info">
                <div class="info-list">
                    <div class="info-item">
                        <div class="label">合同类型：</div>
                        <div class="content">{{ Orders_Type == 0 ? '销售订单' : Customer_info.Orders_Type == 1 ? '服务订单' : '' }}</div>
                    </div>
                    <div class="flex">
                        <div class="info-item" v-if="PipelineCustomer.ID">
                            <div class="label">商机编号：</div>
                            <div class="content">{{ PipelineCustomer.ID + ' [' + PipelineCustomer.opportunityName + ']' }}</div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item" v-if="Customer_info.Customer_Type != '1'">
                            <div class="label">客户编号：</div>
                            <div class="content label-middle">{{ Customer_info.Customer_Code }}</div>
                        </div>
                        <div class="info-item">
                            <div class="label">客户名称：</div>
                            <div class="content ">{{ Customer_info.Customer_Name }}</div>
                        </div>
                        <div class="info-item" v-if="Customer_info.Customer_Type == '1'">
                            <div class="label">客户手机：</div>
                            <div class="content">{{ Customer_info.Person_Mobile }}</div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">客户类型：</div>
                            <div class="content label-middle">{{ Customer_info.Customer_Type == '1' ? '个人客户' : '企业客户' }}</div>
                        </div>
                        <div class="info-item" v-if="Customer_info.Customer_Type == 0">
                            <div class="label">注册所在地：</div>
                            <div class="content">{{ Customer_info.Customer_RegAddr }}</div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">会员等级：</div>
                            <div class="content label-middle">{{ Customer_info.Grade_Name }}</div>
                        </div>
                    </div>
                    <div class="info-item">
                        <div class="label">付款方式：</div>
                        <div class="content">{{ submitpaymentObj.value }}</div>
                    </div>
                </div>
            </div>
            <div class="form-title">
                <svg-icon icon-class="lm" class-name="lm-icon" />
                工程信息
            </div>
            <div class="info">
                <div class="info-list">
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">工程区域：</div>
                            <div class="content">{{ confirmOrderInfo.Customer_Project_Site_Name }}</div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">项目类型：</div>
                            <div class="content">{{ confirmOrderInfo.Orders_ProjectType_Name }}</div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">工程名称：</div>
                            <div class="content">{{ confirmOrderInfo.Customer_Project_Name }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-title">
                <svg-icon icon-class="lm" class-name="lm-icon" />
                供货信息
            </div>
            <div class="info">
                <div class="info-list">
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">预计供货时间：</div>
                            <div class="content">{{ confirmOrderInfo.SPCApply_PlanDeliveryDays | formatDate }}</div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">办事处：</div>
                            <div class="content">{{ confirmOrderInfo.officeInfoDetail }}</div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">业务员：</div>
                            <div class="content">{{ confirmOrderInfo.SPCApply_OfficeManName }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-title" v-if="confirmOrderInfo.specialOffer == 1 && SPCApply_BillType != 0">
                <svg-icon icon-class="lm" class-name="lm-icon" />
                特价信息
            </div>
            <div class="info specialOffer-info" v-if="confirmOrderInfo.specialOffer == 1 && SPCApply_BillType != 0">
                <div class="info-list">
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">业务区域：</div>
                            <div class="content">GST</div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">合作规模：</div>
                            <div class="content">
                                {{ confirmOrderInfo.Special_FutureScale || 0 }} 元
                                <span class="color999">含税价，申请人与客户未来12个月的合作规模</span>
                            </div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">A类预期平均折扣：</div>
                            <div class="content">
                                {{ confirmOrderInfo.Special_FutureAvgDiscount || 0 }} %
                                <span class="color999">若输入8，则为价格的8%（折扣率0.08）,申请人与客户未来12个月预期平均折扣</span>
                            </div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">B类预期平均折扣：</div>
                            <div class="content">
                                {{ confirmOrderInfo.Special_FutureAvgDiscountB || 0 }} %
                                <span class="color999">若输入8，则为价格的8%（折扣率0.08）,申请人与客户未来12个月预期平均折扣</span>
                            </div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">新客户：</div>
                            <div class="content">
                                {{ confirmOrderInfo.Special_IsNewCustomer == 1 ? '是' : '否' }}
                            </div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">客户简介：</div>
                            <div class="content">
                                {{ confirmOrderInfo.Special_CustomerIntro }}
                            </div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">多期开发规则：</div>
                            <div class="content">
                                {{ confirmOrderInfo.Special_IsMoreTermsPlan == 1 ? '是' : '否' }}
                                <span class="color999 ml10">项目未来有多期开发的规划</span>
                            </div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">折扣仅使用于此项目：</div>
                            <div class="content">
                                {{ confirmOrderInfo.Special_IsNoLow == 1 ? '是' : '否' }}
                                <span class="color999 ml10">折扣仅适用于此项目，未来折扣不会低于此次申请</span>
                            </div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">业务背景：</div>
                            <div class="content">{{ confirmOrderInfo.Special_BusinessIntro }} {{ confirmOrderInfo.Special_BusinessNote }}</div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">报价单价格有效期：</div>
                            <div class="content">{{ confirmOrderInfo.Special_Start | formatDate }} - {{ confirmOrderInfo.Special_End | formatDate }}</div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">特价类型：</div>
                            <div class="content">
                                {{ confirmOrderInfo.Special_Type }}
                            </div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">是否根据图纸预估销售额：</div>
                            <div class="content">
                                {{ confirmOrderInfo.Special_IsPaper == 1 ? '是' : '否' }}
                            </div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">项目是否为独家专供：</div>
                            <div class="content">
                                {{ confirmOrderInfo.Special_ExpertRate }}
                                %
                                <span class="color999">折扣低于对应销售类型“SPC最低折扣”时必填</span>
                            </div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">库存订单未来发货金额：</div>
                            <div class="content">
                                {{ confirmOrderInfo.Special_LaterFreightAmount }}
                                元
                                <span class="color999">含税价,在手订单后续将发货金额</span>
                            </div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">原折扣率发货：</div>
                            <div class="content">
                                {{ confirmOrderInfo.Special_IsSourceDiscountFreight == 1 ? '是' : '否' }}
                                <span class="color999 ml10">折扣若输入8，则为价格的8折，折扣仅可设置为0.3-3折</span>
                            </div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">竞争对手信息：</div>
                            <div class="content">
                                <el-table :data="competitorData" style="width: 100%" border :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                                    <el-table-column prop="Competitor_Name" label="名称" align="center">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.Competitor_Name }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Competitor_CateADiscount" label="A类折扣" align="center">
                                        <template slot-scope="scope">
                                            {{ scope.row.Competitor_CateADiscount }}
                                            折
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Competitor_CateBDiscount" label="B类折扣" align="center">
                                        <template slot-scope="scope">
                                            {{ scope.row.Competitor_CateBDiscount }}
                                            折
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <span class="color999 mt10">折扣若输入8，则为价格的8折，折扣仅可设置为0.3-3折</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-title" v-if="SPCApply_BillType != 0 && (officeInfo.ReturnGoodsLimit == 0 || SPCApply_ReturnGoodsPrice)">
                <svg-icon icon-class="lm" class-name="lm-icon" />
                返货信息
            </div>
            <div class="info" v-if="SPCApply_BillType != 0 && (officeInfo.ReturnGoodsLimit == 0 || SPCApply_ReturnGoodsPrice)">
                <div class="info-list">
                    <div class="info-item">
                        <div class="label">是否返货：</div>
                        <div class="content">
                            <el-radio-group v-model="IsReturnGoods">
                                <el-radio label="1">是</el-radio>
                                <el-radio label="0">否</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                    <div class="info-item" v-if="IsReturnGoods == '1'">
                        <div class="label">返货金额：</div>
                        <div class="content">
                            <el-input class="el-select-medium" v-model="SPCApply_ReturnGoodsPrice" @input="blurReturnGoodsPrice" placeholder="返货金额"></el-input>
                        </div>
                    </div>
                    <div class="info-item" v-if="IsReturnGoods == '1'">
                        <div class="label">返货比例：</div>
                        <div class="content">
                            <el-input class="el-select-medium" v-model="SPCApply_ReturnGoodsPriceRate" @input="blurReturnGoodsPriceRate" placeholder="返货比例"></el-input>
                            %
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-title">
                <svg-icon icon-class="lm" class-name="lm-icon" />
                商品清单
            </div>
            <div class="cart-list-container">
                <div class="cart-list" v-for="item in cartList" :key="item.ID">
                    <div class="flex">
                        <div class="cart-top-title-big mr10">
                            <span>{{ item.DiscountCateName }}</span>
                        </div>
                    </div>
                    <div>
                        <el-table :data="item.Goods" style="width: 100%" border :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                            <el-table-column prop="Goods_Product_MainBoxNumber" label="主机箱号" align="center" show-overflow-tooltip width="100"></el-table-column>
                            <el-table-column prop="Goods_Product_TypeName" label="销售组" align="center" show-overflow-tooltip width="140"></el-table-column>
                            <el-table-column prop="Goods_Product_Name" label="商品名称" align="left" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="Goods_Product_Spec" label="规格" align="center" show-overflow-tooltip width="160"></el-table-column>
                            <el-table-column prop="Goods_Product_Price" label="单价" align="center" width="100">
                                <template v-slot="scope">
                                    <div>￥{{ scope.row.Goods_Product_Price.toFixed(2) }}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Goods_Product_AdjustDiscountPrice" label="折扣价" width="100" align="center" show-overflow-tooltip>
                                <template v-slot="scope">
                                    <div>￥{{ scope.row.Goods_Product_AdjustDiscountPrice.toFixed(2) }}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Goods_Amount" label="数量" align="center" width="100"></el-table-column>
                            <el-table-column prop="Goods_TotalPrice" label="合计" align="center" width="150">
                                <template v-slot="scope">
                                    <div>￥{{ scope.row.Goods_TotalPrice.toFixed(2) }}</div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="total">
                        商品金额合计:
                        <span>￥{{ item.Porduct_Pirce || 0 }}</span>
                        订单金额:
                        <span>￥{{ item.Orders_Price || 0 }}</span>
                        折扣率:{{ Number(((item.Orders_Price / item.Porduct_Pirce) * 100).toFixed(2)) }}%
                        <span>{{ Number((item.Orders_Price / item.Porduct_Pirce) * 10).toFixed(3) | formatePrice3}}折</span>
                    </div>
                </div>
            </div>
            <div class="cart-list-container mt20" v-if="activityCartList && activityCartList.length > 0">
                <div class="form-title" style="margin-top: 0">
                    <svg-icon icon-class="lm" class-name="lm-icon" />
                    促销商品
                </div>
                <div class="cart-list" v-for="item in activityCartList" :key="item.ID">
                    <div class="flex">
                        <div class="cart-top-title-big mr10">
                            <span>{{ item.DiscountCateName }}</span>
                        </div>
                    </div>
                    <div>
                        <el-table :data="item.Goods" style="width: 100%" border :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                            <el-table-column prop="Goods_Product_MainBoxNumber" label="主机箱号" align="center" show-overflow-tooltip width="100"></el-table-column>
                            <el-table-column prop="Goods_Product_TypeName" label="销售组" align="center" show-overflow-tooltip width="140"></el-table-column>
                            <el-table-column prop="Goods_Product_Name" label="商品名称" align="left" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="Goods_Product_Spec" label="规格" align="center" show-overflow-tooltip width="160"></el-table-column>
                            <el-table-column prop="Goods_Product_Price" label="单价" align="center" width="100">
                                <template v-slot="scope">
                                    <div>￥{{ scope.row.Goods_Product_Price.toFixed(2) }}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Goods_Product_AdjustDiscountPrice" label="折扣价" width="100" align="center" show-overflow-tooltip>
                                <template v-slot="scope">
                                    <div>￥{{ scope.row.Goods_Product_AdjustDiscountPrice.toFixed(2) }}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Goods_Amount" label="数量" align="center" width="100"></el-table-column>
                            <el-table-column prop="Goods_TotalPrice" label="合计" align="center" width="150">
                                <template v-slot="scope">
                                    <div>￥{{ scope.row.Goods_TotalPrice.toFixed(2) }}</div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="total">
                        商品金额合计:
                        <span>￥{{ item.Porduct_Pirce || 0 }}</span>
                        订单金额:
                        <span>￥{{ item.Orders_Price || 0 }}</span>
                        折扣率:{{ Number(((item.Orders_Price / item.Porduct_Pirce) * 100).toFixed(2)) }}%
                        <span>{{ Number((item.Orders_Price / item.Porduct_Pirce) * 10).toFixed(3) | formatePrice3}}折</span>
                    </div>
                </div>
            </div>
            <div class="total">
                报价单总金额:
                <span>￥{{ allPrice || 0 }}</span>
            </div>
        </el-form>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: 'submitSpcOrder',
    props: {
        Customer_info: {
            type: Object,
            default: () => ({})
        },
        submitpaymentObj: {
            type: Object,
            default: () => ({})
        },
        // 商机信息
        PipelineCustomer: {
            type: Object,
            default: () => ({})
        },
        //订单类型: 0销售订单1服务订单
        Orders_Type: {
            type: Number,
            default: 0
        },
        //交易类型:0：正常交易 1报价单2打包订单
        TradeType: {
            type: Number,
            default: 0
        },
        //合同来源: 0报价单1合同变更2独立合同
        Orders_SourceCate: {
            type: Number,
            default: 2
        },
        // 返货总金额
        allReturnPrice: {
            type: [Number, String],
            default: 0
        },
        cartList: {
            type: Array,
            default: () => []
        },
        activityCartList: {
            type: Array,
            default: () => []
        },
        competitorData: {
            type: Array,
            default: () => []
        },
        // 1正式报价单 0临时
        SPCApply_BillType: {
            type: Number,
            default: 1
        }
    },
    mounted() {
        this.GetBranchOfficeByToken();
    },
    computed: {
        ...mapState({
            countryList: (state) => state.common.countryList,
            provinceList: (state) => state.common.provinceList,
            cityList: (state) => state.common.cityList,
            districtList: (state) => state.common.districtList
        }),
        combinedCartItems() {
            return [...this.cartList, ...this.activityCartList];
        },
        allPrice() {
            return this.combinedCartItems.reduce((total, item) => total + (item.Orders_Price || 0), 0).toFixed(2);
        }
    },
    data() {
        return {
            cityListopt: [], //城市list
            districtListopt: [], //区县list
            officeManID: '',
            offinceList: [],

            SupplierList: [],

            Orders_ESignStatus: '', // 电子签章状态
            Orders_ESignName: '', // 电子签章名称
            Orders_EsignMobile: '', // 电子签章手机
            performanceList: [], //业绩划分列表
            performance_note: '', //业绩划分备注说明
            Orders_IsPayAuditDelivery: [], //  1付款审核后直接发货 0付款审核后不直接发货
            confirmOrderInfo: '', //合同确认页面参数

            confirmOrderInfo: {},
            IsReturnGoods: '0', //是否返货
            SPCApply_ReturnGoodsPrice: '', // 返货金额
            SPCApply_ReturnGoodsPriceRate: '', //返货比例
            officeInfo: {} // 办事处信息
        };
    },
    methods: {
        // 合同确认页面方法
        comfirmSpcOrderMethos(orderInfo) {
            this.confirmOrderInfo = orderInfo;
            console.log('orderInfo', orderInfo);
            console.log('this.confirmOrderInfo', this.confirmOrderInfo);
        },
        // 提取合同确认页面参数
        getSpcOrderConfirmParams() {
            this.confirmOrderInfo.isconfirm = 2;
            if (this.IsReturnGoods == '1') {
                this.confirmOrderInfo.IsReturnGoods = this.IsReturnGoods;
                this.confirmOrderInfo.SPCApply_ReturnGoodsPrice = this.SPCApply_ReturnGoodsPrice;
                this.confirmOrderInfo.SPCApply_ReturnGoodsPriceRate = this.SPCApply_ReturnGoodsPriceRate;
            }
            let json = this.confirmOrderInfo;
            return json;
        },
        // 返货金额
        blurReturnGoodsPrice() {
            if (this.hasMoreThanTwoDecimals(this.SPCApply_ReturnGoodsPrice)) {
                this.$nextTick(() => {
                    this.SPCApply_ReturnGoodsPrice = Number(this.SPCApply_ReturnGoodsPrice).toFixed(2);
                });
            }
            if (this.SPCApply_ReturnGoodsPrice > +this.allReturnPrice) {
                this.$message('返货金额不能超过订单总额');
                this.SPCApply_ReturnGoodsPriceRate = 100.0;
                this.SPCApply_ReturnGoodsPrice = this.allReturnPrice;
            } else {
                this.SPCApply_ReturnGoodsPriceRate = ((this.SPCApply_ReturnGoodsPrice / this.allReturnPrice) * 100).toFixed(2);
            }
        },
        // 返货比例
        blurReturnGoodsPriceRate() {
            if (this.hasMoreThanTwoDecimals(this.SPCApply_ReturnGoodsPriceRate)) {
                this.$nextTick(() => {
                    this.SPCApply_ReturnGoodsPriceRate = Number(this.SPCApply_ReturnGoodsPriceRate).toFixed(2);
                });
            }
            if (this.SPCApply_ReturnGoodsPriceRate > 100) {
                this.$message('返货比例不能超过100%');
                this.SPCApply_ReturnGoodsPriceRate = 100.0;
                this.SPCApply_ReturnGoodsPrice = this.allReturnPrice;
            } else {
                this.SPCApply_ReturnGoodsPrice = ((this.allReturnPrice * this.SPCApply_ReturnGoodsPriceRate) / 100).toFixed(2);
            }
        },
        // 判断是否大于两位小数
        hasMoreThanTwoDecimals(num) {
            // 转换为字符串
            const numStr = num.toString();
            // 检查是否有小数点
            if (numStr.includes('.')) {
                const decimalPart = numStr.split('.')[1]; // 获取小数部分
                return decimalPart.length > 2; // 判断小数位数是否 > 2
            }
            return false; // 没有小数部分，直接返回 false
        },
        // 根据办事处用户查询所属办事处信息
        async GetBranchOfficeByToken() {
            var result = await this.$newsApi.order.GetBranchOfficeByToken();
            if (result.data.Resultcode == 0) {
                this.officeInfo = result.data.data;
            }
        }
    }
};
</script>

<style scoped lang="scss">
/deep/ .lm-icon {
    margin-right: 10px;
}
.mt0 {
    margin-top: 0 !important;
}

.mt10 {
    margin-top: 10px;
}

.ml10 {
    margin-left: 10px;
}
.mr10 {
    margin-right: 10px;
}
.mb10 {
    margin-bottom: 10px;
}
.tip {
    font-size: 12px;
    color: #999999;
    margin-left: 10px;
}

.form-title {
    margin: 40px 0 20px 0;
    font-size: 16px;
    font-weight: 700;
}
.flex {
    display: flex;
    align-items: center;
}

.info {
    // width: 600px;

    .info-title {
        font-size: 16px;
        font-weight: 700;
    }

    .info-item {
        display: flex;
        margin: 10px 0;
        font-size: 14px;
        color: #000000;

        .label {
            width: 100px;
        }

        .content {
            flex: 1;
            height: auto;
        }
    }

    .label-middle {
        width: 100px;
    }
}
.specialOffer-info {
    .info-item {
        .label {
            width: 170px;
        }
    }
}
.cart-list-container {
    border: 1px solid #e4e7ed;
    border-radius: 15px;
    padding: 20px 25px 10px 25px;
}
.cart-list {
    background-color: #ffffff;
    font-size: 14px;
    .cart-top {
        font-weight: 700;
        margin-bottom: 10px;
        .cart-top-title {
            .title-contetn {
                font-size: 14px;
                margin-right: 10px;
            }
        }
    }
    .cart-top-title-big {
        font-size: 14px;
        font-weight: 700;
        margin-bottom: 10px;
    }
}
.total {
    font-size: 14px;
    text-align: right;
    margin-top: 10px;
    span {
        color: red;
        padding-right: 20px;
    }
}
</style>
